import { useEffect, useState } from 'react';
import type { DesktopUpdateState } from '@/auth/desktopAuth';

export const useDesktopUpdateState = (): DesktopUpdateState | null => {
  const [state, setState] = useState<DesktopUpdateState | null>(null);
  const updates = window.edgelexDesktop?.updates;

  useEffect(() => {
    if (!updates) return;
    let active = true;
    void updates.getState().then((nextState) => {
      if (active) setState(nextState);
    }).catch(() => undefined);
    const unsubscribe = updates.onStateChange((nextState) => {
      if (active) setState(nextState);
    });
    return () => {
      active = false;
      unsubscribe();
    };
  }, [updates]);

  return state;
};
